
<template>
  <nav
    :class="[
      'container__menuoptionsnaigation',
      { 'container__menuoptionsnaigation--active': isMenuHamburguerActive },
    ]"
  >
    <ul class="container__menuoptionsnaigation__menu">
      <li
        class="container__menuoptionsnaigation__menu__options"
        v-for="(menuOption, key) in menuOptions"
        :key="key"
      >
        <a
          :class="[
            'container__menuoptionsnaigation__menu__options__item',
            {
              'container__menuoptionsnaigation__menu__options__item--active':
                menuOption.subMenuActive,
            },
          ]"
          :title="menuOption.menuItem"
          @click="changeSubmenuActive(menuOption, menuOption.subMenuActive)"
          >{{ menuOption.menuItem }}</a
        >
        <ul
          :class="[
            'container__menuoptionsnaigation__menu__options__submenu',
            {
              'container__menuoptionsnaigation__menu__options__submenu--active':
                menuOption.subMenuActive,
            },
          ]"
        >
          <li
            class="container__menuoptionsnaigation__menu__options__submenu__list"
            v-for="(subItem, key) in menuOption.subItens"
            :key="key"
          >
            <a
              class="container__menuoptionsnaigation__menu__options__submenu__list_item"
              @click="changeRoute(subItem.link)"
              >{{ subItem.name }}</a
            >
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>



<script>
export default {
  props: {
    menuOptions: Array,
    isMenuHamburguerActive: Boolean,
    cleanActiveSubmenuActive: Function,
    changeMenuHamburguerActive: Function,
  },
  methods: {
    /**
     * Deixa apenas o ultimo submenu clicado ativo
     */
    changeSubmenuActive(menuOption, isActive) {
      if (window.innerWidth < 992) {
        this.cleanActiveSubmenuActive(menuOption);
        menuOption.subMenuActive = !isActive;
      }
    },
    /**
     * Muda a rota atual do usuario quando clicado no menu
     */
    changeRoute(linkName) {
      const isAlreadyInRoute = this.$route.matched.some(
        (m) => m.path.substring(1) === linkName
      );
      if (!isAlreadyInRoute) {
        this.$router.push({ name: linkName });
        if (this.isMenuHamburguerActive) {
          this.changeMenuHamburguerActive();
        }
      }
    },
  },
};
</script>


<style scoped>
.container__menuoptionsnaigation {
  position: absolute;
  height: 100vh;
  width: 80vw;
  max-width: 18rem;
  background-color: white;
  padding-left: 1rem;
  top: 2.5rem;
  left: -18rem;
  transition: left 0.5s ease-in-out;
  font-size: 0.75rem;
  user-select: none;
}

.container__menuoptionsnaigation--active {
  left: 0;
}

.container__menuoptionsnaigation__menu__options {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  width: 100%;
}

.container__menuoptionsnaigation__menu__options__item {
  width: 100%;
  list-style-type: none;
  color: var(--color-gray);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  
}

.container__menuoptionsnaigation__menu__options__item:hover,
.container__menuoptionsnaigation__menu__options__item--active {
  color: var(--color-navy-blue);
  font-weight: 700;
}

.container__menuoptionsnaigation__menu__options__submenu {
  height: 0;
  width: 0;
  padding: 0 !important;
  overflow: hidden;
 
}

.container__menuoptionsnaigation__menu__options__submenu--active {
  height: auto;
  width: auto;
}

.container__menuoptionsnaigation__menu__options__submenu__list {
  display: flex;
  flex-direction: column;

}

.container__menuoptionsnaigation__menu__options__submenu__list_item {
  font-weight: 300;
  color: var(--color-gray);
  cursor: pointer;
  width: 100%;
  padding: 0.1rem 1rem;
  
}

.container__menuoptionsnaigation__menu__options__submenu__list_item:hover {
  font-weight: 500;
  background-color: var(--color-navy-blue);

}

@media screen and (min-width: 992px) {
  .container__menuoptionsnaigation {
    position: static;
    height: 100%;
    width: 100%;
    max-width: unset;
    padding: 0;
  }

  .container__menuoptionsnaigation__menu {
    height: 100%;
    padding-left:24px;
  }

  .container__menuoptionsnaigation__menu__options {
    display: inline-block;
    vertical-align: middle;
    width: auto;
    padding: 0.5rem 1rem;
    margin: 0;
    height: 100%;
  }
  .container__menuoptionsnaigation__menu__options__item {
    width: auto;
  }
  .container__menuoptionsnaigation__menu__options__item::before {
    display: block;
    content: attr(title);
    font-weight: 700;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
  .container__menuoptionsnaigation__menu__options:hover
    .container__menuoptionsnaigation__menu__options__submenu,
  .container__menuoptionsnaigation__menu__options__submenu:hover {
    position: absolute;
    top: 2.5rem;
    background-color: white;
    height: auto;
    width: auto;
    box-shadow: 0px 17px 34px -10px rgba(0, 0, 0, 0.35);
  }
  .container__menuoptionsnaigation__menu__options__submenu__list_item {
    background-color: var(--color-light-blue);
  }
}
</style>